import React, {useEffect, useState} from "react";
import API from "../api/config";
import {FiChevronLeft, FiChevronRight} from "react-icons/fi";

const GalleryViewer = ({qrId, onClose}) => {
    const [images, setImages] = useState([]);
    const [index, setIndex] = useState(0);
    const [loading, setLoading] = useState(true);
    const [boxNote, setBoxNote] = useState("");

    useEffect(() => {
        const loadImages = async () => {
            try {
                const res = await API.get(`/registrations/gallery/${qrId}`);

                let imgs = res.data.images || [];

                // handle stringified / bad JSON
                if (typeof imgs === "string") {
                    try {
                        imgs = JSON.parse(imgs);
                    } catch {
                        imgs = [];
                    }
                }

                setImages(Array.isArray(imgs) ? imgs : []);
                setBoxNote(res.data.box_note || "");
                setIndex(0);
            } catch (err) {
                console.error("Gallery load failed", err);
                onClose?.();
            } finally {
                setLoading(false);
            }
        };

        loadImages();
    }, [qrId, onClose]);

    const prev = () => setIndex((i) => (i === 0 ? images.length - 1 : i - 1));

    const next = () => setIndex((i) => (i === images.length - 1 ? 0 : i + 1));

    if (loading) {
        return <div className="fixed inset-0 bg-black text-white flex items-center justify-center">Loading…</div>;
    }

    if (!images.length) {
        return (
            <div className="fixed inset-0 bg-black text-white flex items-center justify-center">No images found</div>
        );
    }

    return (
        <div className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center px-3">
            {/* Card */}
            <div className="relative w-full max-w-md bg-white rounded-2xl shadow-2xl overflow-hidden">
                {/* Close */}

                {/* Image wrapper */}
                <div className="relative bg-black flex items-center justify-center">
                    <img src={images[index]} alt="" className="w-full max-h-[70vh] object-contain" draggable={false} />

                    {/* Left arrow */}
                    {images.length > 1 && (
                        <button
                            onClick={prev}
                            className="absolute left-3 top-1/2 -translate-y-1/2 bg-white text-black rounded-full w-8 h-8 flex items-center justify-center shadow hover:scale-105 transition"
                        >
                            <FiChevronLeft size={18} />
                        </button>
                    )}

                    {/* Right arrow */}
                    {images.length > 1 && (
                        <button
                            onClick={next}
                            className="absolute right-3 top-1/2 -translate-y-1/2 bg-white text-black rounded-full w-8 h-8 flex items-center justify-center shadow hover:scale-105 transition"
                        >
                            <FiChevronRight size={18} />
                        </button>
                    )}

                    {/* Counter */}
                    <div className="absolute bottom-3 right-3 bg-black/70 text-white text-xs px-2 py-1 rounded-full">
                        {index + 1} / {images.length}
                    </div>
                </div>

                {/* Footer (optional – future use) */}
                
                <div className="px-4 py-3 text-base text-gray-800 text-center font-semibold">
                    {boxNote || "Shared via QR"}
                </div>
            </div>
        </div>
    );
};

export default GalleryViewer;
